import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col gap-y-2 mt-4 w-full justify-between"
}
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "relative flex items-center w-full h-[22px] max-h-[22px] bg-[#f3f0e9] rounded-full p-[2px] border border-[#e8e2d8] select-none" }
const _hoisted_4 = {
  key: 2,
  class: "flex gap-x-1 overflow-x-auto no-scrollbar mt-4 w-full justify-between"
}
const _hoisted_5 = ["onClick", "onMouseover"]
const _hoisted_6 = { class: "w-full aspect-square rounded-2xl flex overflow-hidden bg-[#f8f5ee]" }
const _hoisted_7 = ["src", "srcset"]
const _hoisted_8 = { class: "text-parameter-title text-[10px] font-medium overflow-hidden mx-auto text-center mt-1" }
const _hoisted_9 = {
  key: 0,
  class: "text-parameter-text text-[9px] overflow-hidden mx-auto text-center"
}
const _hoisted_10 = {
  key: 3,
  class: "w-full mt-4"
}
const _hoisted_11 = { class: "w-full mb-4" }
const _hoisted_12 = { class: "relative flex items-center w-full h-[22px] max-h-[22px] overflow-x-auto no-scrollbar bg-[#f3f0e9] rounded-full p-[2px] border border-[#e8e2d8] select-none" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex gap-x-1 overflow-x-auto no-scrollbar mb-4 w-full justify-between" }
const _hoisted_15 = ["onClick", "onMouseover"]
const _hoisted_16 = { class: "w-full aspect-square rounded-2xl flex overflow-hidden bg-[#f8f5ee]" }
const _hoisted_17 = ["src", "srcset"]
const _hoisted_18 = { class: "text-parameter-title text-[10px] font-medium overflow-hidden mx-auto text-center mt-1" }
const _hoisted_19 = {
  key: 0,
  class: "text-parameter-text text-[9px] overflow-hidden mx-auto text-center"
}

import ItemV3ParameterBox from "@/components/itemV3/parameter/itemV3ParameterBox.vue";
import ItemV3RemoveGroupModal from "@/components/itemV3/parameter/itemV3RemoveGroupModal.vue";
import ItemV3StonesList from "@/components/itemV3/parameter/stones/itemV3StonesList.vue";
import ItemV3StonesGroupSingle from "@/components/itemV3/parameter/stones/itemV3StonesGroupSingle.vue";
import ItemV3StonesGroupRows from "@/components/itemV3/parameter/stones/itemV3StonesGroupRows.vue";
import ItemV3StonesGroupCrown from "@/components/itemV3/parameter/stones/itemV3StonesGroupCrown.vue";
import {computed, inject, nextTick, ref, watch} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import ItemV3StonesGroupStarrySky from "@/components/itemV3/parameter/stones/itemV3StonesGroupStarrySky.vue";
import {getCurrentText} from "@/assets/ts/itemText";

const imageWidthPercent: number = 30
const boxIdx = "stones"


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3Stones',
  props: ["item"],
  emits: ["patch"],
  setup(__props, { emit: __emit }) {


const {t} = useI18n();

const emit = __emit;
const props = __props;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");
const patchMultiple = inject<any>("patchMultiple");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

const loading = ref(false)

/**
 * Parameter box header images
 */

const mainMetal = computed(() => store.getters["session/getMainMetal"])
const getHeaderImage = (size: string = "600x300", withBg = false) => {
  if (withBg) {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${mainMetal.value}_${boxIdx}.webp`
  } else {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${boxIdx}.webp`
  }
}

/**
 * session
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])

// used only for its imageUrl() helper (which does not depend on variantIdx), so no
// specific variant idx is needed here
const parametersVariations = new ParametersVariations("", configureAll, session, itemIdx, loadItemVariants)

// Tracks the box's own open/closed state (bound via v-model:open below) instead of a
// hardcoded "false", so it survives re-renders triggered by a patch - see
// itemV3ParameterBox.vue's onUpdated hook, which re-asserts this value on every update.
const open = ref(false)

const currentStonesText = computed(() => {
  const text = getCurrentText(
      configureAll.value ? -1 : itemIdx.value, [
        "stones.*.stone_setting",
        "stones.*.stone_size",
        "stones.*.stone_quality"
  ], true)

  if (text.includes(", , ")) {
    return text.replace(", , ", t('components.parameters.stones.no_stones'))
  }

  return text
})

/**
 * stone layout types
 */

const stoneLayoutTypes = [
  "noStones", // no stones at all - a plain ring
  "single", // a stone group with one or more single stones
  "row", // a row of stones
  "crown", // a row of stones with the special crown setting
  "starry_sky", // Starry sky stones settings
]

/**
 * stone layout type labels / images
 *
 * Renders the "no stones" / "add stones" horizontal list below the stone group list.
 * "noStones" removes all stones and the remaining types (single/row/crown) add a new
 * stone group with that layout.
 */

const stoneLayoutLabels: Record<string, string> = {
  noStones: "Ohne Steine",
  single: "Einzelner Stein",
  row: "Steinreihe",
  crown: "Kronen-fassung",
  starry_sky: "Sternen-himmel",
}

const getStoneLayoutLabel = (layoutType: string) => stoneLayoutLabels[layoutType] || layoutType

// subtitles shown below the title of each layout card, matching the attached layout
const stoneLayoutSubtitles: Record<string, string> = {
  noStones: "Klassisch",
  single: "Dezent",
  row: "Zeitlos",
  crown: "Randlos",
  starry_sky: "Funkelnd",
}

const getStoneLayoutSubtitle = (layoutType: string) => stoneLayoutSubtitles[layoutType] || ""

const getStoneLayoutImageUrl = (layoutType: string, size: 300 | 600 = 600) => {
  return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_layout/${size}/${layoutType}.webp`
}

/**
 * group title
 *
 * The group title is related to the group's stoneLayout (e.g. "Steinreihe #1",
 * "Sternenhimmel #3") - each layout has its own text stored in de.json, falling back
 * to the generic "Stein-Gruppe #n" text when the layout has no dedicated entry.
 */

const stoneGroupNameTypes = ["single", "row", "crown", "starry_sky"]

const getStoneGroupTitle = (group: any) => {
  const key = stoneGroupNameTypes.includes(group.stone_layout) ? group.stone_layout : "default"
  return t('components.parameters.stoneGroupNames.' + key, {n: group.group_idx + 1})
}

const handleStoneLayoutClick = (layoutType: string) => {
  if (layoutType === "noStones") {
    confirmRemoveStones(`stones.remove`)
    return
  }
  // Only expect a new group to show up for the item currently displayed here - e.g. not
  // when "only ring 1" is selected and this component shows a different item.
  if (!hasMultipleItems.value || applyToBothRings.value || itemIdx.value === 0) {
    pendingNewGroupLayout.value = layoutType
  }
  handleValuePatch("stones.add", layoutType)
}

/**
 * stone group layout click (while a stone group is selected)
 */

const handleGroupLayoutClick = (layoutType: string) => {
  if (layoutType === "noStones") {
    confirmRemoveStones(`stones.${activeGroupIdx.value}.remove`)
    return
  } else if (layoutType != activeGroupLayout.value) {
    handleValuePatch(`stones.${activeGroupIdx.value}.add`, layoutType)
  }
}

/**
 * remove stones / stone group
 *
 * Shared with itemV3Grooves.vue / itemV3StonesList.vue's remove confirmation modal:
 * the actual patch (either removing all stones or just the active group) is only sent
 * once the user confirms.
 */

const showRemoveModal = ref(false)
const pendingRemoveAction = ref<string | null>(null)

const confirmRemoveStones = (actionIdx: string) => {
  pendingRemoveAction.value = actionIdx
  showRemoveModal.value = true
}

const pendingRemoveItemName = computed(() => {
  const action = pendingRemoveAction.value
  if (!action) return ''
  if (action === 'stones.remove') return 'Alle Steine'

  const match = action.match(/^stones\.(\d+)\.remove$/)
  if (match) {
    const groupIdx = parseInt(match[1])
    const group: any = stoneGroupList.value.find((g: any) => g.group_idx === groupIdx)
    if (group) return getStoneGroupTitle(group)
  }
  return ''
})

const handleRemoveStones = () => {
  if (pendingRemoveAction.value) {
    const actionIdx = pendingRemoveAction.value
    handleValuePatch(actionIdx, 'remove')
    if (actionIdx === `stones.${activeGroupIdx.value}.remove`) {
      activeGroupIdx.value = -1
    }
  }
  showRemoveModal.value = false
  pendingRemoveAction.value = null
}

/**
 * target items (to which item(s) a newly added stone group is applied)
 *
 * "Only ring 1" / "both rings" choice used when adding a new stone group (stones.add)
 * in a multi-item session.
 */

const applyToBothRings = ref(false)

const hasMultipleItems = computed(() => (session.value?.items?.length || 0) > 1)

const ringsSliderStyle = computed(() => {
  const width = 100 / 2;
  const left = (applyToBothRings.value ? 1 : 0) * width;

  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
})

/**
 * image
 */



const imageUrl = computed(() => parametersVariations.imageUrl([], -1))

/**
 * stone group selection
 *
 * The list of current stone groups and the "select a group" / "add"/"remove" logic
 * lives in itemV3StonesList.vue (transferred from itemV3Grooves.vue). It reports the
 * current groups back via the "groups" event, and the active group is kept here so the
 * switch-button bar and the stone group details below can both react to it.
 */

/**
 * stone groups
 *
 * Transferred from itemV3Grooves.vue's "grooves" computed: scans the current item's
 * variants for idx patterns "stones.<n>.<attr>" (ignoring the "add"/"remove" actions)
 * and groups them by <n> into one object per stone group.
 */

const stoneGroups = computed(() => {
  const groups: any = {}

  if (session.value && session.value.items && session.value.items[itemIdx.value]) {
    const firstItemVariants = session.value.items[itemIdx.value].variants || {};

    for (const key in firstItemVariants) {
      const variant = firstItemVariants[key];
      if (!variant?.idx) continue;

      const parts = variant.idx.split('.');

      if (parts[0] != "stones" || parts.length != 3) continue
      if (parts[2] == "add" || parts[2] == "remove") continue

      const groupIdx = parseInt(parts[1].toString())
      const groupIdxStr = "IDX" + groupIdx

      if (typeof groups[groupIdxStr] == "undefined") {
        groups[groupIdxStr] = {
          "group_idx": groupIdx,
          "stone_layout": "",
          "stone_type": "",
          "stone_quality": "",
          "stone_size": "",
          "key": {}
        }
      }

      groups[groupIdxStr][parts[2]] = variant["text"]
      groups[groupIdxStr].stone_layout = variant["stone_layout"]
      groups[groupIdxStr]["key"][parts[2]] = variant["key"] || ""

    }
  }

  return groups
})

const stoneGroupList = computed(() => Object.values(stoneGroups.value))

const activeGroupIdx = ref(-1)

/**
 * stone group layout (which of the group-detail components is shown)
 *
 * Set via the stoneLayoutTypes list rendered above the stone group details: "single",
 * "row" and "crown" pick the matching component, "noStones" removes the current group
 * instead - mirroring handleStoneLayoutClick.
 */

const activeGroupLayout = computed(() => activeGroupIdx.value !== -1 ? stoneGroups.value["IDX" + activeGroupIdx.value]?.stone_layout : null)

// Set to true right before activeGroupIdx is changed programmatically (see "open newly
// added stone group" below), so the watcher right after doesn't reset the layout that
// was just chosen for that same navigation.
let skipActiveGroupLayoutReset = false

watch(activeGroupIdx, () => {
  if (skipActiveGroupLayoutReset) {
    skipActiveGroupLayoutReset = false
    return
  }
})

/**
 * open newly added stone group
 *
 * handleStoneLayoutClick sets pendingNewGroupLayout before sending the "stones.add"
 * patch - the group itself only exists once the session has reloaded with it, so this
 * watches stoneGroups (fed by itemV3StonesList.vue's "groups" event) for the group_idx
 * that wasn't there before and opens it directly in the matching layout view.
 */

const pendingNewGroupLayout = ref<string | null>(null)
let previousStoneGroupIdxs: number[] = []

watch(stoneGroups, (newGroups) => {
  const newGroupIdxs = Object.values(newGroups).map((group: any) => group.group_idx)

  // Only jump into the first group when a new group was actually added. Any other patch
  // (e.g. changing a stone parameter within group 2) keeps the currently active group.
  if (pendingNewGroupLayout.value !== null && newGroupIdxs.length !== previousStoneGroupIdxs.length) {
    if (newGroupIdxs.length > previousStoneGroupIdxs.length) {
      activeGroupIdx.value = 0
    } else {
      activeGroupIdx.value = -1
    }
    pendingNewGroupLayout.value = null
  }


  previousStoneGroupIdxs = newGroupIdxs
})

const stoneGroupTabIdx = computed(() => {
  if (activeGroupIdx.value === -1) return 0
  const idx = stoneGroupList.value.findIndex((group: any) => group.group_idx === activeGroupIdx.value)
  return idx === -1 ? 0 : idx + 1
})

/**
 * stone group slider
 *
 * The tab buttons size themselves to their own text (min-w-max) instead of being
 * forced into equal percentage-wide slots, so long group titles never overflow. That
 * means the sliding highlight can no longer be positioned with a simple percentage
 * calculation - it has to measure the actual active button's position/width in the DOM.
 */

const stoneGroupTabRefs = ref<(HTMLElement | null)[]>([])

const setStoneGroupTabRef = (el: any, idx: number) => {
  stoneGroupTabRefs.value[idx] = el
}

const stoneGroupSliderRect = ref({left: 0, width: 0})

const updateStoneGroupSliderRect = () => {
  const button = stoneGroupTabRefs.value[stoneGroupTabIdx.value]
  if (button) {
    stoneGroupSliderRect.value = {left: button.offsetLeft + 2, width: button.offsetWidth - 4}
  }
}

watch([stoneGroupTabIdx, stoneGroups], () => nextTick(updateStoneGroupSliderRect), {immediate: true})

const stoneGroupSliderStyle = computed(() => ({
  width: `${stoneGroupSliderRect.value.width}px`,
  left: `${stoneGroupSliderRect.value.left}px`,
}))

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  const patchValue = (typeof value === "string") ? value : value.idx

  if (actionIdx === "stones.add" && hasMultipleItems.value && patchMultiple) {
    let targetItemIdxs = [itemIdx.value]

    if (configureAll.value) {
      targetItemIdxs = applyToBothRings.value
        ? session.value.items.map((_: any, idx: number) => idx)
        : [0]
    }

    const items = targetItemIdxs.map((idx: number) => ({
      itemIdx: idx,
      action: actionIdx,
      value: patchValue
    }));

    patchMultiple(items);
    return;
  }

  emit('patch', {
    action: actionIdx,
    value: patchValue,
    certificated_diamond: typeof value === "string" ? undefined : value.certificated_diamond
  });
};

/**
 * tip texts
 */

const hoverLayoutType = ref<string | null>(null)

const getTipTitle = computed(() => {
  const key = hoverLayoutType.value || "common"
  return t('components.parameters.tips.stones.' + key + '.title')
})

const getTipText = computed(() => {
  const key = hoverLayoutType.value || "common"
  return t('components.parameters.tips.stones.' + key + '.text')
})

const getStoneLayoutTipImageUrl = (layoutType: string, size: 300 | 600 = 600) => {
  return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/tips/stone_layout/${size}/${layoutType}.webp`
}

const getTipImageUrl = computed(() => {
  if (!hoverLayoutType.value) return getStoneLayoutTipImageUrl("common")
  return getStoneLayoutTipImageUrl(hoverLayoutType.value)
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ItemV3ParameterBox, {
      open: open.value,
      "onUpdate:open": _cache[11] || (_cache[11] = ($event: any) => ((open).value = $event)),
      "image-width-percent": imageWidthPercent,
      image: imageUrl.value,
      "header-image": getHeaderImage(),
      "header-image-srcset": getHeaderImage() + ' 300w, ' + getHeaderImage('1200x600') +' 600w',
      title: "Steinbesatz",
      subtitle: currentStonesText.value || 'Wählen Sie die Steinbesatz für Ihre Trauringe',
      loading: loading.value,
      "tip-title": getTipTitle.value,
      "tip-text": getTipText.value,
      "tip-image": getTipImageUrl.value
    }, {
      main: _withCtx(() => [
        (activeGroupIdx.value === -1)
          ? (_openBlock(), _createBlock(ItemV3StonesList, {
              key: 0,
              "active-group-idx": activeGroupIdx.value,
              "onUpdate:activeGroupIdx": _cache[0] || (_cache[0] = ($event: any) => ((activeGroupIdx).value = $event)),
              stoneGroups: stoneGroups.value,
              onPatch: _cache[1] || (_cache[1] = (event) => emit('patch', event))
            }, null, 8, ["active-group-idx", "stoneGroups"]))
          : _createCommentVNode("", true),
        (activeGroupIdx.value === -1 && hasMultipleItems.value && configureAll.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("nav", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "absolute top-[2px] bottom-[2px] bg-brand-main rounded-full transition-all duration-300 ease-in-out shadow-xs pointer-events-none",
                    style: _normalizeStyle(ringsSliderStyle.value)
                  }, null, 4),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["text-[10px] tracking-wided relative flex-1 flex cursor-pointer items-center justify-center text-xs transition-colors duration-200 z-10 font-normal leading-none h-full", !applyToBothRings.value ? 'text-white font-medium' : 'text-gray-500 hover:text-gray-700']),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (applyToBothRings.value = false))
                  }, " Nur Ring 1 ", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["text-[10px] tracking-wided relative flex-1 flex cursor-pointer items-center justify-center text-xs transition-colors duration-200 z-10 font-normal leading-none h-full", applyToBothRings.value ? 'text-white font-medium' : 'text-gray-500 hover:text-gray-700']),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (applyToBothRings.value = true))
                  }, " Beide Ringe ", 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (activeGroupIdx.value === -1)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stoneLayoutTypes, (layoutType) => {
                return _createElementVNode("li", {
                  key: layoutType,
                  class: "shrink-0 flex-1 cursor-pointer flex flex-col items-center gap-1 py-2 px-1 rounded-2xl border-2 border-transparent bg-white hover:bg-[#f3f0e9]",
                  onClick: ($event: any) => (handleStoneLayoutClick(layoutType)),
                  onMouseover: ($event: any) => (hoverLayoutType.value = layoutType),
                  onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (hoverLayoutType.value = null))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: getStoneLayoutImageUrl(layoutType, 300),
                      srcset: getStoneLayoutImageUrl(layoutType, 600),
                      class: "w-full h-full object-cover",
                      alt: ""
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(getStoneLayoutLabel(layoutType)), 1),
                  (getStoneLayoutSubtitle(layoutType))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(getStoneLayoutSubtitle(layoutType)), 1))
                    : _createCommentVNode("", true)
                ], 40, _hoisted_5)
              }), 64))
            ]))
          : _createCommentVNode("", true),
        (activeGroupIdx.value !== -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("nav", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "absolute top-[2px] bottom-[2px] bg-brand-main rounded-full transition-all duration-300 ease-in-out shadow-xs pointer-events-none",
                    style: _normalizeStyle(stoneGroupSliderStyle.value)
                  }, null, 4),
                  _createElementVNode("button", {
                    ref: (el) => setStoneGroupTabRef(el, 0),
                    type: "button",
                    class: _normalizeClass(["text-[10px] tracking-wided text-nowrap relative flex-1 min-w-max flex cursor-pointer items-center justify-center px-3 text-xs transition-colors duration-200 z-10 font-normal leading-none h-full", activeGroupIdx.value === -1 ? 'text-white font-medium' : 'text-gray-500 hover:text-gray-700']),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (activeGroupIdx.value = -1))
                  }, " Übersicht ", 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stoneGroupList.value, (group, index) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: group.group_idx,
                      ref_for: true,
                      ref: (el) => setStoneGroupTabRef(el, index + 1),
                      type: "button",
                      class: _normalizeClass(["text-[10px] tracking-wided text-nowrap relative flex-1 min-w-max flex cursor-pointer items-center justify-center px-3 text-xs transition-colors duration-200 z-10 font-normal leading-none h-full", activeGroupIdx.value === group.group_idx ? 'text-white font-medium' : 'text-gray-500 hover:text-gray-700']),
                      onClick: ($event: any) => (activeGroupIdx.value = group.group_idx)
                    }, _toDisplayString(getStoneGroupTitle(group)), 11, _hoisted_13))
                  }), 128))
                ])
              ]),
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stoneLayoutTypes, (layoutType) => {
                  return _createElementVNode("li", {
                    key: layoutType,
                    class: _normalizeClass(["shrink-0 flex-1 cursor-pointer flex flex-col items-center gap-1 py-2 px-1 rounded-2xl border-2 bg-white hover:bg-[#f3f0e9]", activeGroupLayout.value === layoutType ? 'border-brand-main bg-[#f3f0e9]' : 'border-transparent']),
                    onClick: ($event: any) => (handleGroupLayoutClick(layoutType)),
                    onMouseover: ($event: any) => (hoverLayoutType.value = layoutType),
                    onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (hoverLayoutType.value = null))
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        src: getStoneLayoutImageUrl(layoutType, 300),
                        srcset: getStoneLayoutImageUrl(layoutType, 600),
                        class: "w-full h-full object-cover",
                        alt: ""
                      }, null, 8, _hoisted_17)
                    ]),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(getStoneLayoutLabel(layoutType)), 1),
                    (getStoneLayoutSubtitle(layoutType))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(getStoneLayoutSubtitle(layoutType)), 1))
                      : _createCommentVNode("", true)
                  ], 42, _hoisted_15)
                }), 64))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      details: _withCtx(() => [
        (activeGroupLayout.value === 'single')
          ? (_openBlock(), _createBlock(ItemV3StonesGroupSingle, {
              key: 0,
              "group-idx": activeGroupIdx.value,
              onPatch: _cache[7] || (_cache[7] = (event) => emit('patch', event))
            }, null, 8, ["group-idx"]))
          : (activeGroupLayout.value === 'row')
            ? (_openBlock(), _createBlock(ItemV3StonesGroupRows, {
                key: 1,
                "group-idx": activeGroupIdx.value,
                onPatch: _cache[8] || (_cache[8] = (event) => emit('patch', event))
              }, null, 8, ["group-idx"]))
            : (activeGroupLayout.value === 'crown')
              ? (_openBlock(), _createBlock(ItemV3StonesGroupCrown, {
                  key: 2,
                  "group-idx": activeGroupIdx.value,
                  onPatch: _cache[9] || (_cache[9] = (event) => emit('patch', event))
                }, null, 8, ["group-idx"]))
              : (activeGroupLayout.value === 'starry_sky')
                ? (_openBlock(), _createBlock(ItemV3StonesGroupStarrySky, {
                    key: 3,
                    "group-idx": activeGroupIdx.value,
                    onPatch: _cache[10] || (_cache[10] = (event) => emit('patch', event))
                  }, null, 8, ["group-idx"]))
                : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open", "image", "header-image", "header-image-srcset", "subtitle", "loading", "tip-title", "tip-text", "tip-image"]),
    _createVNode(ItemV3RemoveGroupModal, {
      modelValue: showRemoveModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showRemoveModal).value = $event)),
      "item-name": pendingRemoveItemName.value,
      onConfirm: handleRemoveStones
    }, null, 8, ["modelValue", "item-name"])
  ], 64))
}
}

})